const delay = (ms: number) =>
  new Promise<void>((resolve) => {
    setTimeout(resolve, ms)
  })

export const downloadFromUrl = async (url: string, name: string) => {
  const link = document.createElement('a')
  link.href = url
  link.download = name
  document.body.appendChild(link)
  link.click()
  document.body.removeChild(link)
  await delay(200)
}

export const downloadEvidence = async (urls: string[]) => {
  for (let i = 0; i < urls.length; i += 1) {
    // eslint-disable-next-line no-await-in-loop
    await downloadFromUrl(urls[i], `evidencia_${i + 1}.jpg`)
  }
}

export const downloadQrFromUrl = async (url: string, name: string) => {
  const response = await fetch(url, {
    mode: 'cors'
  })

  const blob = await response.blob()
  const blobUrl = window.URL.createObjectURL(blob)

  const link = document.createElement('a')
  link.href = blobUrl
  link.download = name
  document.body.appendChild(link)
  link.click()

  document.body.removeChild(link)
  window.URL.revokeObjectURL(blobUrl)
}
